import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const LinkedInIcon = (props: SvgProps) => (
  <Svg
    width={22}
    height={22}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M18.563 2.234H3.438a1.203 1.203 0 0 0-1.204 1.204v15.124a1.203 1.203 0 0 0 1.204 1.204h15.124a1.203 1.203 0 0 0 1.204-1.203V3.438a1.203 1.203 0 0 0-1.203-1.204Zm.171 16.328a.171.171 0 0 1-.172.172H3.438a.172.172 0 0 1-.171-.172V3.438a.172.172 0 0 1 .171-.171h15.126a.172.172 0 0 1 .171.171v15.126ZM8.078 9.626v5.5a.516.516 0 1 1-1.031 0v-5.5a.516.516 0 1 1 1.031 0Zm7.563 2.406v3.094a.516.516 0 1 1-1.032 0v-3.094a1.89 1.89 0 1 0-3.78 0v3.094a.516.516 0 1 1-1.032 0v-5.5a.516.516 0 1 1 1.031 0v.181a2.922 2.922 0 0 1 4.813 2.225ZM8.42 7.22a.86.86 0 1 1-1.718 0 .86.86 0 0 1 1.719 0Z"
    />
  </Svg>
)
export default LinkedInIcon
